$.extend(travelc, {
    originMarkerHtml: '<div class="map-marker marker-sm-container origin-marker zoom-visible marker0"><span><i class="fa fa-flag"></i></span></div>',
    allMarkerData: {},
    colorDivRoute: "div.js-travel-route__point",
    divDroppables: '.design__map-composer, .c-destinations-options',
    singleMarkers: {},
    cargaCiudades: function (callback) {
        for (let tour of this.readClosedTours()) {
            for (let destination of tour.destinations) {
                travelc.allMarkerData[destination.id] = destination;
            }
        }
        callback.apply();
    },
    drawAllLines: function () {
        if (this.destinationRoutes.length === 0) {
            travelc.mapRoute = new MapRoute([], "trip");
            return;
        }
        var lines = [];
        for (var i = 1; i < this.destinationRoutes.length; i++) {
            lines.push({
                startMarker: this.destinationRoutes[i - 1].marker,
                endMarker: this.destinationRoutes[i].marker,
                color: "rgba(0,0,0,0.7)",
                width: travelc.mapInteractive ? null : 2
            });
        }
        lines = this.addOriginAndEndLines(lines);
        travelc.mapRoute = new MapRoute(lines, "trip");
        travelc.mapRoute.addTo(travelc.map);
    },
    drawTrip: function () {
        if (travelc.map) {
            travelc.loadDestinationRoutes();
            travelc.setRoutePositionsSingleMarkers();
            travelc.drawBeginEndMarkers();
            this.drawAllLines();
        }
    },
    addOriginAndEndLines: function (lines) {
        if (travelc.beginLocation) {
            lines.unshift({
                startMarker: travelc.beginLocation,
                endMarker: this.destinationRoutes[0].marker,
                color: "rgba(0,0,0,0.7)"
            });
        }
        if (travelc.endLocation) {
            lines.push({
                startMarker: this.destinationRoutes[this.destinationRoutes.length - 1].marker,
                endMarker: travelc.endLocation,
                color: "rgba(0,0,0,0.7)"
            });
        }
        return lines;
    },
    initDestinationRouteMap: function (preview = false) {
        if (travelc.map) {
            travelc.map.remove();
            travelc.map = null;
            travelc.singleMarkers = {};
        }
        if (travelc.isShowMap()) {
            travelc.boundsPadding = {
                top: preview ? 55 : 115,
                bottom: preview ? 10 : 30,
                left: preview ? 10 : 30,
                right: preview ? 10 : 30
            };
            travelc.mapAnimateRouteLines = !preview;
            travelc.mapContainerId = preview ? "destination-preview-map" : "destination-large-map";
            travelc.mapControls = {
                attribution: {position: preview ? "top-left" : "bottom-right"},
                centerTrip: !preview,
                navigation: !preview
            };
            travelc.mapInteractive = !preview;
            travelc.mapOptions.singleDestinationZoom = preview ? 2 : 3;
            travelc.initOnce(preview ? "basic" : "default");
        }
    },centerTrip: function () {
        if (this.destinationRoutes.length === 0) {
            if (travelc.isGroupCoach() && travelc.isRoutingMode()) {
                travelc.map.flyTo({center: [this.groupCoachLongitude, this.groupCoachLatitude], zoom: 10});
            } else {
                travelc.map.flyTo({center: [this.center.longitude, this.center.latitude], zoom: travelc.center.zoom - 1});
            }
        } else if (this.destinationRoutes.length === 1) {
            travelc.map.flyTo({center: this.destinationRoutes[0].marker.getLngLat(), zoom: travelc.mapOptions.singleDestinationZoom});
        } else {
            const bounds = this.getBoundsToFitDestinations();
            if (travelc.isRoutingEngine()) {
                bounds.extend(travelc.mapRoute.getBounds());
            }
            travelc.map.fitBounds(bounds, {padding: travelc.boundsPadding, animate: false});
        }
    }
});

$.extend(DestinationMarker.prototype, maplibregl.Marker.prototype, {
    getIcon: function () {
        if (this.isPartOfRoute()) {
            if (this.options.routePosition.length === 1) {
                function getIconContent(routePosition) {
                    return routePosition.itinerary + 1;
                }
                let description = this.data.description === undefined ? "" : this.data.description;
                return '<div class="marker map-marker route-marker marker' + this.options.routePosition[0].color + '" title="' + this.data.name + '">' +
                    '<span title="' + description + '">' + getIconContent(this.options.routePosition[0]) + '</span>' +
                    '</div>';
            } else {
                let descriptionStart = this.data.descriptionstart === undefined ? "" : this.data.descriptionstart;
                return '<div class="marker map-marker markerY" title="' + this.data.name + '"><span title="' + descriptionStart + '"><i class="fas fa-sync"/></span></div>';
            }
        } else {
            return '<div class="marker map-marker" title="' + this.data.name + '" data-destination-id="' + this.data.id + '">' +
                '<span class="img"  style="background-image:url(\'' + this.data.img + '\');"><i class="fa fa-spin fa-spinner ico-opening"/></span></div>';
        }
    },
    onClick: function () {
    }
});
